import moment from 'moment';
import React from 'react';

import styles from './MonthView.css';

const Cell = ({ date, events, inactive, ...props }) => (
  <div className={[styles.day, inactive ? styles.inactive : ''].join(' ')} {...props}>
    <h5>{moment(date).format('D')}</h5>
    <span>{events.filter((e) => e.job).length} Jobs</span><br/>
    <span>{events.filter((e) => e.purchaseOrder).length} Deliveries</span><br/>
    <span>{events.filter((e) => e.bid).length} Bids</span>
  </div>
);

export default Cell;
